import './img-button.scss'

const ImgButton = (props: any) => {
    const { disabled,className = '', onClick, children, ...rest } = props

    const onKeyDown = (event: any) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            event.stopPropagation()
            onClick(event)
        }
    }

    return (
        <div
            role="button"
            tabIndex={disabled ? -1 : 0} 
            className={`img-button focus-ring ${className} ${disabled ? 'disabled' : ''}`} 
            onKeyDown={disabled ? undefined : onKeyDown} 
            onClick={disabled ? undefined : onClick} 
            aria-disabled={disabled}
            {...rest}
            >
            {children}
        </div>
    )
}

export default ImgButton;